// Central biomarker definitions — used across all dashboards, Rico, and upload forms

export const BIOMARKER_GROUPS = {
  cardiovascular: {
    label: 'Blood Pressure & Cardiovascular',
    color: '#ef4444',
    markers: {
      systolicBP:   { label: 'Systolic Blood Pressure',  unit: 'mmHg', low: 90,  optimal: [90, 120],  border: [120, 140], high: 140 },
      diastolicBP:  { label: 'Diastolic Blood Pressure', unit: 'mmHg', low: 60,  optimal: [60, 80],   border: [80, 90],   high: 90 },
      pulseRate:    { label: 'Pulse Rate',                unit: 'bpm',  low: 50,  optimal: [50, 80],   border: [80, 100],  high: 100 },
    }
  },
  glucose: {
    label: 'Glucose & Diabetes',
    color: '#f59e0b',
    markers: {
      fastingGlucose:    { label: 'Fasting Glucose',     unit: 'mmol/L', low: null, optimal: [3.5, 5.5], border: [5.6, 6.9], high: 7.0 },
      hba1c:            { label: 'HbA1c',                unit: '%',      low: null, optimal: [0, 5.7],   border: [5.7, 6.4],  high: 6.5 },
    }
  },
  lipids: {
    label: 'Lipid Panel',
    color: '#00AEEF',
    markers: {
      totalCholesterol:  { label: 'Total Cholesterol',   unit: 'mmol/L', low: null, optimal: [0, 5.0],   border: [5.0, 6.0],  high: 6.0 },
      hdl:              { label: 'HDL Cholesterol',      unit: 'mmol/L', low: 1.0,  optimal: [1.2, 99],  border: [1.0, 1.2],  high: null },
      ldl:              { label: 'LDL Cholesterol',      unit: 'mmol/L', low: null, optimal: [0, 3.0],   border: [3.0, 4.0],  high: 4.0 },
      triglycerides:    { label: 'Triglycerides',        unit: 'mmol/L', low: null, optimal: [0, 1.7],   border: [1.7, 2.3],  high: 2.3 },
      nonHdl:           { label: 'Non-HDL Cholesterol',  unit: 'mmol/L', low: null, optimal: [0, 4.0],   border: [4.0, 5.0],  high: 5.0 },
      cholHdlRatio:     { label: 'Chol/HDL Ratio',       unit: 'ratio',  low: null, optimal: [0, 4.5],   border: [4.5, 6.0],  high: 6.0 },
    }
  },
  renal: {
    label: 'Renal Function',
    color: '#8b5cf6',
    markers: {
      sodium:           { label: 'Sodium',               unit: 'mmol/L', low: 133,  optimal: [133, 146], border: null,        high: 146 },
      potassium:        { label: 'Potassium',            unit: 'mmol/L', low: 3.5,  optimal: [3.5, 5.3], border: null,        high: 5.3 },
      urea:             { label: 'Urea',                 unit: 'mmol/L', low: 2.5,  optimal: [2.5, 7.8], border: null,        high: 7.8 },
      creatinine:       { label: 'Creatinine',           unit: 'umol/L', low: 64,   optimal: [64, 104],  border: null,        high: 104 },
      egfr:             { label: 'eGFR',                 unit: 'ml/min', low: 60,   optimal: [60, 200],  border: [45, 60],    high: null },
    }
  },
  liver: {
    label: 'Liver Function',
    color: '#10b981',
    markers: {
      alt:              { label: 'ALT',                  unit: 'U/L',    low: null, optimal: [0, 50],    border: [50, 100],   high: 100 },
      ast:              { label: 'AST',                  unit: 'U/L',    low: null, optimal: [0, 40],    border: [40, 80],    high: 80 },
      alkalinePhosphatase: { label: 'Alkaline Phosphatase', unit: 'U/L', low: 30,  optimal: [30, 130],  border: null,        high: 130 },
      ggt:              { label: 'Gamma GT',             unit: 'U/L',    low: null, optimal: [0, 50],    border: [50, 100],   high: 100 },
      bilirubin:        { label: 'Bilirubin',            unit: 'umol/L', low: null, optimal: [0, 21],    border: [21, 35],    high: 35 },
      albumin:          { label: 'Albumin',              unit: 'g/L',    low: 35,   optimal: [35, 50],   border: [30, 35],    high: null },
      totalProtein:     { label: 'Total Protein',        unit: 'g/L',    low: 60,   optimal: [60, 80],   border: null,        high: 80 },
    }
  },
  thyroid: {
    label: 'Thyroid Function',
    color: '#ec4899',
    markers: {
      tsh:              { label: 'TSH',                  unit: 'mU/L',   low: 0.35, optimal: [0.35, 4.94], border: [4.94, 10], high: 10 },
      t4:               { label: 'Free T4',              unit: 'pmol/L', low: 9.0,  optimal: [9.0, 19.1],  border: null,       high: 19.1 },
    }
  },
  fbc: {
    label: 'Full Blood Count',
    color: '#f97316',
    markers: {
      haemoglobin:      { label: 'Haemoglobin',          unit: 'g/L',    low: 130,  optimal: [130, 170], border: [115, 130],  high: null },
      whiteBloodCells:  { label: 'White Blood Cells',    unit: 'x10^9/L',low: 4.0,  optimal: [4.0, 11.0],border: null,        high: 11.0 },
      platelets:        { label: 'Platelets',            unit: 'x10^9/L',low: 150,  optimal: [150, 400], border: [100, 150],  high: 400 },
      redBloodCells:    { label: 'Red Blood Cells',      unit: 'x10^12/L',low: 4.5, optimal: [4.5, 5.5], border: null,        high: 5.5 },
      mcv:              { label: 'MCV',                  unit: 'fL',     low: 80,   optimal: [80, 100],  border: null,        high: 100 },
    }
  },
  vitamins: {
    label: 'Vitamins & Minerals',
    color: '#06b6d4',
    markers: {
      ferritin:         { label: 'Ferritin',             unit: 'ug/L',   low: 30,   optimal: [30, 400],  border: [13, 30],    high: null },
      vitaminB12:       { label: 'Vitamin B12',          unit: 'pmol/L', low: 145,  optimal: [145, 637], border: [100, 145],  high: null },
      folate:           { label: 'Folate',               unit: 'nmol/L', low: 7.0,  optimal: [7.0, 999], border: [4.0, 7.0],  high: null },
      vitaminD:         { label: 'Vitamin D',            unit: 'nmol/L', low: 50,   optimal: [50, 200],  border: [30, 50],    high: null },
      uricAcid:         { label: 'Uric Acid',            unit: 'mmol/L', low: null, optimal: [0.2, 0.43],border: [0.43, 0.5], high: 0.5 },
      crp:              { label: 'CRP',                  unit: 'mg/L',   low: null, optimal: [0, 5.0],   border: [5.0, 10],   high: 10 },
    }
  }
};

export function getStatus(groupKey, markerKey, value) {
  if (!value) return 'none';
  const v = parseFloat(value);
  const group = BIOMARKER_GROUPS[groupKey];
  if (!group) return 'none';
  const marker = group.markers[markerKey];
  if (!marker) return 'none';

  // HDL is special — higher is better
  if (markerKey === 'hdl' || markerKey === 'egfr' || markerKey === 'haemoglobin' || markerKey === 'ferritin' || markerKey === 'vitaminB12' || markerKey === 'folate' || markerKey === 'vitaminD') {
    if (marker.low && v < marker.low) return 'bad';
    if (marker.border && v >= marker.border[0] && v < marker.border[1]) return 'warn';
    return 'ok';
  }

  if (marker.high && v >= marker.high) return 'bad';
  if (marker.border && v >= marker.border[0]) return 'warn';
  if (marker.low && v < marker.low) return 'bad';
  return 'ok';
}

export function getStatusLabel(groupKey, markerKey, value) {
  const status = getStatus(groupKey, markerKey, value);
  const labels = { ok: 'Optimal', warn: 'Borderline', bad: 'Outside range', none: 'Not recorded' };
  return labels[status] || 'Not recorded';
}

export function getAllMarkerKeys() {
  const keys = [];
  Object.values(BIOMARKER_GROUPS).forEach(group => {
    Object.keys(group.markers).forEach(k => keys.push(k));
  });
  return keys;
}

export function findMarkerGroup(markerKey) {
  for (const [groupKey, group] of Object.entries(BIOMARKER_GROUPS)) {
    if (group.markers[markerKey]) return { groupKey, group, marker: group.markers[markerKey] };
  }
  return null;
}
